import './briefe.css';
import { Link } from 'react-router-dom';
import { t } from '../../i18n';
import { NoteRow } from '../belege/Bell';
import { LETTER_NOTES } from '../belege/labels';
import { useNotifications } from '../belege/shared';
import { briefePath } from './labels';

// Teile der Übersicht, die zu Briefen gehören.

// Kommentare der Kanzlei zu Briefen und „Brief erledigt“, bis sie geöffnet sind (bei mehreren Firmen mit Firmennamen)
export function BriefeNotices() {
  const notes = useNotifications();
  const items = (notes.data?.items ?? []).filter((n) => LETTER_NOTES.has(n.type) && !n.read);
  if (!items.length) return null;
  return (
    <div className="notice" role="status">
      {items.map((n) => (
        <NoteRow key={n.id} item={n} />
      ))}
    </div>
  );
}

// Großer Knopf „✉ Neuen Brief hochladen“ für die oben gewählte Firma
export function BriefeCta({ clientId }: { clientId: string }) {
  return (
    <Link className="cta brief" to={`${briefePath(clientId)}?neu=1`}>
      <span>
        <b>✉ {t('Neuen Brief hochladen')}</b>
        <small>{t('Post von Ämtern, Krankenkasse, Bank & Co. · Foto oder PDF')}</small>
      </span>
      <span className="chev" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
